import { render } from "./MinistryForm.vue?vue&type=template&id=00ae1e7e"
import script from "./MinistryForm.vue?vue&type=script&lang=js"
export * from "./MinistryForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__